import type { EnvironmentEnum } from '@ztechapps/common.contract'
import { getWindow, hasWindow } from '@ztechapps/common.utils'

// Shape of window.__ENV__ — env supplied at container runtime (server.mjs) or by
// the dev Vite plugin, so a single build serves any environment. Client-visible
// values only (public URLs/keys); secrets never leave the backend.
type RuntimeAppEnv = {
  environment?: EnvironmentEnum
  recaptchaSiteKey?: string
  appFullName?: string
  companyName?: string
}
type RuntimeEnv = {
  app?: RuntimeAppEnv
}

// Runtime env injected into window.__ENV__ — by server.mjs per request in a
// container, or by the dev-only Vite plugin during `nx serve`. Deliberately no
// build-time fallback: a single built artifact must carry no environment values,
// otherwise an image built on beta serves those values after promotion to prod.
const runtimeEnv: RuntimeEnv | undefined = hasWindow()
  ? (getWindow() as unknown as { __ENV__?: RuntimeEnv }).__ENV__
  : undefined
const app = runtimeEnv?.app

export const appSettings = {
  Google: {
    recaptchaSiteKey: app?.recaptchaSiteKey,
  },
  AppFullName: app?.appFullName,
  CompanyName: app?.companyName,
  nodeEnv: app?.environment,
}
